//? A hack so the web version does not crash when using the useSwitchCamera hook
export function useSwitchCamera() {
    return { switchCamera: () => {} }
}
